import Repository from "@shared/services/api/abstracts/Repository";
import { ProductCategoryTypeSerializer } from "../types/products";

export default class PublicBasedProductCategoryRepository extends Repository<ProductCategoryTypeSerializer> {
  public readonly repositoryName = "PublicBasedProductCategoryRepository";

  public readonly endpoint = "api/public/products/categories/";
}
